import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function TAndC() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('dp3.crowdfunding.bundle');
    return (
        <div className={`dp3-crowdfunding-tc ${css['dp3-crowdfunding-tc']}`}>
            {t.rich('t_and_c', {
                title: (text: string) => <p className="title">{text}</p>,
                link1: (text: string) => (
                    <Link className="link" href={'https://jp.ecoflow.com/pages/price-guarantee-delta-pro-3'} target="_blank">
                        {text}
                    </Link>
                ),
                link2: (text: string) => (
                    <a className="link" href={`mailto:${text}`}>
                        {text}
                    </a>
                ),
                link3: (text: string) => (
                    <Link className="link" href={'https://jp.ecoflow.com/pages/warranty-policy'} target="_blank">
                        {text}
                    </Link>
                ),
                link4: (text: string) => (
                    <Link className="link" href={'https://jp.ecoflow.com/pages/online-store-policy'} target="_blank">
                        {text}
                    </Link>
                ),
            })}
        </div>
    );
}
